// extracted by mini-css-extract-plugin
export default {"headerLink":"HeaderLink_headerLink__-e3P5"};